import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AnswerDetailSidebarComponent } from '@app/shared/components/answer-detail-sidebar/answer-detail-sidebar.component';
import { SidebarModule } from 'primeng/sidebar';
import { SharedQuestionDetailModule } from './shared-question-detail.module';
import { SharedAnswerBaseModule } from './shared-answer-base.module';
import { ButtonModule } from 'primeng/button';
import { SharedVinterScoreCardModule } from './shared-vinter-score-card.module';
import { ChangeVinterScoreSidebarComponent } from '@app/shared/components/answer-detail-sidebar/change-vinter-score-sidebar/change-vinter-score-sidebar.component';
import { SliderModule } from 'primeng/slider';
import { EditorModule } from 'primeng/editor';
import { AvatarModule } from 'primeng/avatar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProgressBarModule } from 'primeng/progressbar';
import { SimpleVinterAnswerDetailSidebarComponent } from '@app/shared/components/simple-vinter-answer-detail-sidebar/simple-vinter-answer-detail-sidebar.component';
import { SimpleVinterChangeVinterScoreSidebarComponent } from '@app/shared/components/simple-vinter-answer-detail-sidebar/simple-vinter-change-vinter-score/simple-vinter-change-vinter-score.component';
@NgModule({
  declarations: [
    AnswerDetailSidebarComponent,
    ChangeVinterScoreSidebarComponent,
    SimpleVinterAnswerDetailSidebarComponent,
    SimpleVinterChangeVinterScoreSidebarComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    SidebarModule,
    SharedQuestionDetailModule,
    SharedAnswerBaseModule,
    ButtonModule,
    SliderModule, 
    ProgressBarModule,
    FormsModule,
    ReactiveFormsModule,
    EditorModule, 
    AvatarModule, 
    SharedVinterScoreCardModule
  ],
  exports: [
    AnswerDetailSidebarComponent,
    ChangeVinterScoreSidebarComponent,
    SimpleVinterAnswerDetailSidebarComponent,
    SimpleVinterChangeVinterScoreSidebarComponent
    ]
})
export class SharedAnswerDetailModule { }
